export default class ServiceBase {
  static async _abortIfUnsuccessful(response)  {
    if (!response.ok) {
      const contentType = response.headers.get('content-type');
      if (contentType.indexOf('application/json') > -1) {
        const jsonPayload = await response.json();
        throw new ServiceError(response.status, jsonPayload.type, jsonPayload.error);
      } else {
        throw new ServiceError(response.status, response.type, response.statusText);
      }
    }
  }
}

export class ServiceError  {
  constructor(status, type, message) {
    this.status = status;
    this.type = type;
    this.message = message
  }
}



// WEBPACK FOOTER //
// ./src/services/service_base.js